import { createCapabilitiesStore } from '@rtkwlf/c3-lib-capabilities';

export const capabilities = createCapabilitiesStore([
  { id: 'task_api_read' },
  { id: 'task_api_write_state' },
  { id: 'task_api_write_comment' },
]);
